declare var angular
const template = require('./file_uploader.html.slim')
import { camelize } from 'extensions/helpers'

const isDragDropSupported = function() {
  var div = document.createElement('div');
  return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) &&
    'FormData' in window && 'FileReader' in window;
}();

export class FileUploaderController {
  static $inject = ['$rootScope', '$element', 'railsResource']

  category: string
  client: any
  dialog: boolean
  errorMessage: string
  message: string
  required: string
  sendToAdvisor: boolean
  sendToClient: boolean
  state: string
  userVisible: boolean
  target: string
  method: string

  private _ngModel: any
  private _title
  private _file

  constructor(private $rootScope, private $element, private railsResource) {
    this.setToInitialState();
  }

  setToInitialState() {
    this.model = null
    this.sendToAdvisor = false
    this.sendToClient = true
    this.userVisible = true
    this.target = '/file_assets'
    this.method = 'POST'
    this.state = 'new'
    this.file = null
    this.$element.find('input[type="file"]').val('')
  }

  get model() {
    if (this.ngModel == null) return;
    return this.ngModel.$modelValue
  }
  set model(value) {
    if (this.ngModel == null) return;
    this.ngModel.$setViewValue(value)
    this.ngModel.$render()
  }

  get file() { return this._file; }
  set file(value) {
    this._file = value
    if (!value) return;
    if (this.dialog) {
      // TODO: This is not a very obvious way to handle triggering an edit
      // dialog. It should be changed.
      this.$rootScope.$broadcast('upload_request', this)
      return
    } else {
      this.upload()
    }
  }

  get ngModel() { return this._ngModel }
  set ngModel(value) { this._ngModel = value }

  get title() { return this._title }
  set title(value) { this._title = value }

  get resource() {
    return this.railsResource(this.target + '/:id', { id: '@id' }, {
      upload: {
        method: this.method,
        transformRequest: angular.identity,
        headers: { 'Content-Type': undefined },
        snakeizeRequest: false,
      }
    })
  }

  remove() {
    this.resource.delete({id: this.model.id}).$promise.then((() => this.setToInitialState()));
  }

  get caption() {
    if (this.state === 'uploaded') {
      return 'Success!'
    } else if (isDragDropSupported) {
      return 'Drag or click here to add file'
    } else {
      return 'Click here to add file'
    }
  }

  upload() {
    this.state = 'uploading'
    var fd = new FormData()
    if (this.message) {
      fd.append('message', this.message)
    }
    fd.append('carrierwave', this.file)
    fd.append('category', this.category || 'document')
    fd.append('title', this.title || this.file.name)
    fd.append('user_id', this.client)
    fd.append('send_to_client', this.sendToClient.toString())
    fd.append('send_to_advisor', this.sendToAdvisor.toString())
    fd.append('user_visible', this.userVisible.toString())

    this.resource.upload(fd, (newAsset) => {
      this.uploaded(newAsset)
    }, (error) => {
      this.error(error)
    })
  }

  private uploaded(newAsset) {
    this.errorMessage = null
    this.model = camelize(newAsset)
    this.state = 'uploaded'
    this.$rootScope.$broadcast('fileUploaded', this.model)
  }

  private error(error) {
    this.state = 'error'
    if (error.status === 422) {
      this.errorMessage = error.data.message.replace("Carrierwave", "")
    } else {
      this.errorMessage = 'An error occurred, please contact us.'
    }
  }
}

angular.module('wbComponents').directive('wbFileUploader', function() {
  return {
    scope: {
      asset: '=?',
      category: '@',
      client: '=?',
      dialog: '@',
      required: '@',
      result: '=?',
      target: '@',
    },
    restrict: 'E',
    controller: FileUploaderController,
    controllerAs: 'ctrl',
    bindToController: true,
    replace: true,
    templateUrl: template,
    require: ['wbFileUploader', '?ngModel'],
    transclude: true,
    link: function($scope, $el, $attrs, ctrls) {
      var ctrl: FileUploaderController = ctrls[0]
      ctrl.ngModel = ctrls[1]
      var el = $el[0]
      var button = el.querySelector('.file-uploader-button')
      var input = el.querySelector('input[type="file"]')

      $(input).on('change', (e: any) => {
        if (e.target.files == null) return;
        ctrl.file = e.target.files[0]
      })

      // Taken from: https://css-tricks.com/drag-and-drop-file-uploading/
      if (isDragDropSupported) {
        $(button).on('drag dragstart dragend dragover dragenter dragleave drop', function(e) {
          e.preventDefault();
        })
        .on('dragover dragenter', function() {
          $el.addClass('is-dragover');
        })
        .on('dragleave dragend drop', function() {
          $el.removeClass('is-dragover');
        })
        .on('drop', (e: any) => {
          ctrl.file = e.originalEvent.dataTransfer.files[0];
        });
      }
    }
  }
})
